<form [formGroup]="form" fxLayout="column" fxLayoutAlign="center start" *ngIf="Address">
    <ngx-spinner name="loading-address" [fullScreen]="false" type="ball-clip-rotate-multiple"> </ngx-spinner>

    <mat-form-field fxFlex>
        <mat-label>{{ "ADDRESS.ZIP_CODE" | translate }}</mat-label>
        <input
            [required]="isRequired"
            type="text"
            mask="00000-000"
            matInput
            formControlName="zipCode"
            [(ngModel)]="Address.zipCode"
            (input)="zipCode$.next(Address.zipCode)"
        />
    </mat-form-field>

    <div fxFill fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center start" fxLayoutGap="8px">
        <mat-form-field fxFlex="66" fxFlex.xs fxFill>
            <mat-label>{{ "ADDRESS.STREET" | translate }}</mat-label>
            <input [required]="isRequired" type="text" matInput formControlName="street" [(ngModel)]="Address.street" />
        </mat-form-field>
        <mat-form-field fxFlex="33" fxFlex.xs fxFill>
            <mat-label>{{ "ADDRESS.NUMBER" | translate }}</mat-label>
            <input
                [required]="isRequired"
                type="text"
                mask="099999"
                matInput
                formControlName="number"
                [(ngModel)]="Address.number"
                #inputNumber
                id="inputNumber"
            />
        </mat-form-field>
    </div>

    <div fxFill fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center start" fxLayoutGap="8px">
        <mat-form-field fxFlex fxFill>
            <mat-label>{{ "ADDRESS.COMPLEMENT" | translate }}</mat-label>
            <input type="text" matInput formControlName="complement" [(ngModel)]="Address.complement" />
        </mat-form-field>
        <mat-form-field fxFlex fxFill>
            <mat-label>{{ "ADDRESS.NEIGHBORHOOD" | translate }}</mat-label>
            <input
                [required]="isRequired"
                type="text"
                matInput
                formControlName="neighborhood"
                [(ngModel)]="Address.neighborhood"
            />
        </mat-form-field>
    </div>

    <div fxFill fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center start" fxLayoutGap="8px">
        <mat-form-field fxFlex fxFill>
            <mat-label>{{ "ADDRESS.CITY" | translate }}</mat-label>
            <input [required]="isRequired" type="text" matInput formControlName="city" [(ngModel)]="Address.city" />
        </mat-form-field>
        <mat-form-field fxFlex fxFill>
            <mat-label>{{ "ADDRESS.STATE" | translate }}</mat-label>
            <input
                [required]="isRequired"
                type="text"
                matInput
                formControlName="state"
                [(ngModel)]="Address.state"
                mask="SS"
            />
        </mat-form-field>
    </div>
</form>
